import { render, staticRenderFns } from "./P0235.vue?vue&type=template&id=712b6f37&"
import script from "./P0235.vue?vue&type=script&lang=ts&"
export * from "./P0235.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports